import type { TrackingFn } from '@change-corgi/core-react/tracking';
import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import { openUrlWithHiddenAnchor } from '#src/app/shared/share/utils';
import { copyToClipboard } from '#src/app/shared/utils/clipboard';

import { trackShareSuccess } from './track';

type Options = {
	trackingData: Record<string, string | number | boolean | undefined>;
	trackingEvents: {
		success: string;
	};
};

// eslint-disable-next-line max-params
export function shareReddit(
	title: string,
	url: string,
	{ trackingEvents, trackingData }: Options,
	track: TrackingFn,
	i18nContext: UtilityContext['i18n'],
): void {
	// Trigger and forget — awaiting here would give up the tap's user activation, and the popup
	// blocker then eats the new tab below. Nothing reads the result.
	void copyToClipboard(url, i18nContext);
	const redditUrl = `https://www.reddit.com/submit?url=${encodeURIComponent(url)}&title=${encodeURIComponent(title)}`;
	openUrlWithHiddenAnchor(redditUrl, { newTab: true });
	trackShareSuccess(trackingEvents.success, trackingData, track);
}
